module.exports = __webpack_public_path__ + "static/media/main-herbier.b699f0a4.svg";